import { useParams } from 'react-router-dom';
import { DataTableActions } from 'src/components/DataTable';
import { useModal } from 'src/hooks';
import { isModalComplete } from 'src/components/ModalDialog';
import { useStoreUnitActions } from 'src/redux/helpers';
import solutionsStore from '../../redux';
import { useSolutionUserRoles } from '../../hooks';
import SolutionRuleConfigurationEditContainer from './SolutionRuleConfigurationEditContainer';
import SolutionRuleConfigurationDeleteModal from './SolutionRuleConfigurationDeleteModal';
import { SolutionRuleConfigurationItem } from '../../types/solutionRulesConfiguration';

type Props = {
  item?: SolutionRuleConfigurationItem;
};

function SolutionRuleConfigurationListAction({ item }: Props) {
  const { solutionId } = useParams();
  const actions = useStoreUnitActions(solutionsStore);
  const { isSolutionEditor } = useSolutionUserRoles(solutionId);
  const onClose = (reason) =>
    isModalComplete(reason) && actions.ruleConfiguration(solutionId);

  const [deleteDialog, showDeleteDialog] = useModal(
    SolutionRuleConfigurationDeleteModal,
    {
      item,
      onClose,
    }
  );

  const [editDialog, showEditDialog] = useModal(
    SolutionRuleConfigurationEditContainer,
    {
      item,
      onClose,
    }
  );

  return (
    <DataTableActions
      canEdit={isSolutionEditor}
      canDelete={isSolutionEditor}
      onEdit={showEditDialog}
      onDelete={showDeleteDialog}
      showDelete={true}
    >
      {editDialog}
      {deleteDialog}
    </DataTableActions>
  );
}

export default SolutionRuleConfigurationListAction;
